module.exports = __webpack_public_path__ + "static/media/04.df61a55e.mp3";